import React, { useEffect, useState } from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { DEMO_DATE } from '../../data/demo';
import { defaultExcuses, exceptionTypeLabels, excuseLabels } from '../../data/labels';
import { ExceptionType, ExcuseKey } from '../../types/shared';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { Chip, Field } from '../ui/Form';
const allExcuses: ExcuseKey[] = ['branje', 'sport', 'instrument', 'ucenje', 'hisa', 'vecer', 'soba'];
export function ExceptionSheet() {
  const {
    exceptionSheet,
    closeException
  } = useUi();
  const {
    isAdmin,
    viewer,
    activeMembers,
    submitException
  } = useAppState();
  const [memberId, setMemberId] = useState(viewer.id);
  const [type, setType] = useState<ExceptionType>('bolezen');
  const [from, setFrom] = useState(DEMO_DATE);
  const [to, setTo] = useState(DEMO_DATE);
  const [note, setNote] = useState('');
  const [excuses, setExcuses] = useState<ExcuseKey[]>(defaultExcuses.bolezen);
  useEffect(() => {
    if (!exceptionSheet.open) return;
    const kids = activeMembers.filter(m => m.role === 'otrok');
    setMemberId(exceptionSheet.memberId ?? (isAdmin ? kids[0]?.id ?? viewer.id : viewer.id));
    setType('bolezen');
    setFrom(DEMO_DATE);
    setTo(DEMO_DATE);
    setNote('');
    setExcuses(defaultExcuses.bolezen);
  }, [exceptionSheet.open, exceptionSheet.memberId, isAdmin, viewer.id, activeMembers]);
  const valid = from <= to && excuses.length > 0 && (isAdmin || note.trim().length > 0);
  return <Sheet open={exceptionSheet.open} onClose={closeException} title={isAdmin ? 'Dodaj izjemo' : 'Predlagaj izjemo'} subtitle={isAdmin ? 'Potrjena izjema označi izvedbe kot oproščene.' : 'Predlog gre staršema v potrditev.'} footer={<Button className="w-full" disabled={!valid} onClick={() => {
    submitException({
      memberId,
      type,
      from,
      to,
      note: note.trim(),
      excuses
    });
    closeException();
  }} data-id="element-969" data-mp="12spe599ciss0">
          {isAdmin ? 'Dodaj in odobri' : 'Pošlji predlog'}
        </Button>} data-id="element-968" data-mp="2x4dvfi31v7fk">
      <div className="space-y-4" data-id="element-970" data-mp="37s79f6cq7fgf">
        {isAdmin && <div data-id="element-971" data-mp="37qnsddj8x0dl">
            <p className="mb-1.5 text-sm font-bold" data-id="element-972" data-mp="37u1ssg8cmzie">Za koga</p>
            <div className="flex flex-wrap gap-2" data-id="element-973" data-mp="3buc1i0nj040y">
              {activeMembers.map(m => <Chip key={m.id} active={memberId === m.id} onClick={() => setMemberId(m.id)} color={m.color} data-id="element-974" data-mp="3grlvzuprv5vn">
                  {m.name}
                </Chip>)}
            </div>
          </div>}
        <div data-id="element-975" data-mp="3qiynumbklw1o">
          <p className="mb-1.5 text-sm font-bold" data-id="element-976" data-mp="3qkjkchhg3p26">Vrsta</p>
          <div className="flex flex-wrap gap-2" data-id="element-977" data-mp="3vgi5lw7h8qyd">
            {(Object.keys(exceptionTypeLabels) as ExceptionType[]).map(t => <Chip key={t} active={type === t} onClick={() => {
            setType(t);
            setExcuses(defaultExcuses[t]);
          }} data-id="element-978" data-mp="3fk6ylbr0zge">
                {exceptionTypeLabels[t]}
              </Chip>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3" data-id="element-979" data-mp="1ju6enk5hr9rk">
          <Field label="Od" data-id="element-980" data-mp="1juq19e636mbx">{id => <input id={id} type="date" className="field" value={from} onChange={e => setFrom(e.target.value)} data-id="element-981" data-mp="1jwaloayosow2" />}</Field>
          <Field label="Do" data-id="element-982" data-mp="2blcjgdw5pvn6">{id => <input id={id} type="date" className="field" value={to} min={from} onChange={e => setTo(e.target.value)} data-id="element-983" data-mp="2blm2timp54jw" />}</Field>
        </div>
        <div data-id="element-984" data-mp="27kk9tjjdhoqd">
          <p className="mb-1.5 text-sm font-bold" data-id="element-985" data-mp="27m4wyo3cy5e7">Kaj je oproščeno</p>
          <div className="flex flex-wrap gap-2" data-id="element-986" data-mp="22rhhtfu8unca">
            {allExcuses.map(k => <Chip key={k} active={excuses.includes(k)} onClick={() => setExcuses(xs => xs.includes(k) ? xs.filter(x => x !== k) : [...xs, k])} data-id="element-987" data-mp="1xt67z53y8cu2">
                {excuseLabels[k]}
              </Chip>)}
          </div>
          <p className="mt-1.5 text-xs text-muted" data-id="element-988" data-mp="2qgsa08xj39et">Oskrba živali ostane v skupnem pregledu in jo lahko prevzame drug član.</p>
        </div>
        <Field label={isAdmin ? 'Opomba (neobvezno)' : 'Razlog'} data-id="element-989" data-mp="2f2guzoagwvdg">
          {id => <textarea id={id} rows={2} className="field" value={note} onChange={e => setNote(e.target.value)} placeholder="npr. Vročina, ostajam doma." data-id="element-990" data-mp="212z1ivm88txr" />}
        </Field>
      </div>
    </Sheet>;
}